import { ChartColorByStatus, SUMMARY_LEGEND_STATUSES, } from '../../../../constants/statuses';
import { VISIBLE_PIES_COUNT } from './constants';
var mapSummaryToPiesData = function (summary) {
    var piesData = [];
    summary.forEach(function (domain) {
        // Only for PK
        var grade = domain.grades.find(function (el) { return el.shortName === 'PK'; });
        if (!grade)
            return;
        var values = [];
        SUMMARY_LEGEND_STATUSES.forEach(function (status) {
            var value = {
                id: status,
                value: grade.data[status].length,
                color: ChartColorByStatus[status],
                students: grade.data[status],
                domainName: domain.name,
                gradeName: grade.shortName,
            };
            values.push(value);
        });
        var data = {
            name: domain.name,
            values: values,
            total: grade.totalSkills,
        };
        piesData.push(data);
    }, []);
    return piesData.slice(0, VISIBLE_PIES_COUNT);
};
export { mapSummaryToPiesData };
